var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 15c0-.55.45-1 1-1h17.5c.55 0 1 .45 1 1s-.45 1-1 1H6.25c-.55 0-1-.45-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.29 5.54a.996.996 0 0 1 1.41 0l8.75 8.75c.39.39.39 1.02 0 1.41l-8.75 8.75a.996.996 0 1 1-1.41-1.41L22.33 15l-8.04-8.04a.996.996 0 0 1 0-1.41Z"
  })));
};

export default SvgArrowRight;